import React, { useEffect, useState } from "react";
import { AESEncryption, ApiResDecrypt, decryptData, noDataFound } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import Loader from "../../../Components/Common/Loader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";
// import Loader from "../Common/Loader";

function PartnerIpoInfo() {
  const storeToken = localStorage.getItem("ssoToken");
  // const panNum = localStorage.getItem("ClientPan2");  
  // const panId = localStorage.getItem("panId");
  const [ipoInfo, setIpoInfo] = useState();
  const [loader, setLoader] = useState(true);

  const getIpoInfo = async () => {
    let pan;
    let clientPan = localStorage.getItem("clientPan");
    console.log(clientPan, "clientpan");
    let panID = localStorage.getItem("panId");
    console.log(panID, "panID");
    if (clientPan !== null || " " || undefined) {
      pan = localStorage.getItem("clientPan");
    }
    if (panID !== null || " " || undefined) {
      pan = localStorage.getItem("panId");
    }
    let payloadValue = { pan: pan };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getIpoData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_OVERVIEW.IpoInfo_URL,
        `"${encPayload}"`,
      );
      const ipoInfoResponse = ApiResDecrypt(getIpoData?.data);
      // let decryptedIpo = JSON.parse(ipoInfoResponse);

      setIpoInfo(ipoInfoResponse?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    getIpoInfo();
  }, []);

  return (
    <>
      <div className="col-12 col-lg-6">
        <div className="card-box ipo-info">
          <div className="card-title">
            <h2>{Constants.IPO_Info}</h2>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <>
              {ipoInfo == undefined || ipoInfo.length <= 0 ? (
                noDataFound()
              ) : (
                <table className="table equal-column-width-md">
                  <thead>
                    <tr>
                      <th>{Constants.Open_IPOs}</th>
                      <th>{Constants.Subscribed}</th>
                      <th>{Constants.Number_Lots}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ipoInfo.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item?.openipo}</td>
                          <td>{item?.subscribed}</td>
                          <td>{item?.qty}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PartnerIpoInfo;
